/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Loading } from "@networkraildigitalfactory/components";
import { useOneToOnes } from "../../hooks/useAPI";
import OneToOneFilter from "../Filters/OneToOneFilter";
import OneToOneTable from "./OneToOneTable";
import { getCurrentFinancialYear } from "../../services/utils";
import styles from "../MyOneToOnes/MyOneToOnes.module.css";

const OneToOneContent = (props) => {
  const {
    isLineManagerView,
    setOneToOnesFilters,
    oneToOnesFilters,
    displayAccessDeniedModal,
    employeeEmail,
  } = props;

  const [oneToOnes, setOneToOnes] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const url = `/find-by`;

  const searchObj = {
    financialYear: oneToOnesFilters.year,
    email: isLineManagerView ? employeeEmail : undefined,
  };

  const [{ loading: oneToOnesLoading, error: postError }, executePost] = useOneToOnes(
    {
      method: "POST",
    },
    { manual: true }
  );

  // pass error object up to HoC
  if (isLineManagerView) {
    displayAccessDeniedModal(postError);
  }

  const fetchData = async ({ email, financialYear }) => {
    try {
      setLoading(true);
      const result = await executePost({
        url,
        data: { financialYear, email },
      });
      setOneToOnes(result);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setOneToOnesFilters("year", getCurrentFinancialYear());
    searchObj.financialYear = getCurrentFinancialYear();
    fetchData(searchObj);
  };

  useEffect(() => {
    fetchData(searchObj);
  }, [oneToOnesFilters.year]);

  const onYearChange = (financialYear) => {
    setOneToOnesFilters("year", financialYear);
    searchObj.financialYear = financialYear;
    fetchData(searchObj);
  };

  const makeTableData = () => {
    // Pre-fill empty table
    const tableData = [...Array(13)].map((_, i) => {
      return {
        id: null,
        period: i + 1,
        year: oneToOnesFilters.year,
        prepComplete: false,
        prepStarted: false,
        oneToOneComplete: false,
      };
    });

    oneToOnes?.data?.forEach((item) => {
      tableData[item.period - 1] = {
        id: item._id,
        period: item.period,
        year: oneToOnesFilters.year,
        prepComplete: item.prep.isPrepCompleted || false,
        prepStarted: item.prep.isPrepStarted || false,
        oneToOneComplete: item.isCompleted,
      };
    });

    return tableData;
  };

  return (
    <div className={styles.content_container}>
      <Loading loading={loading} />
      {!oneToOnesLoading && !loading && (
        <>
          <div className={styles.year_title}>Year {oneToOnesFilters.year}</div>
          <div className={styles.row_filters}>
            <OneToOneFilter
              clearFilters={clearFilters}
              onYearChange={onYearChange}
              yearValue={oneToOnesFilters.year}
            />
          </div>

          <div className={`${styles.row_main} ${styles.table_row}`}>
            <OneToOneTable
              tableData={makeTableData()}
              isLineManagerView={isLineManagerView}
              employeeEmail={employeeEmail}
            />
          </div>
          <div className={styles.row_pagination}></div>
        </>
      )}
    </div>
  );
};

export default OneToOneContent;
